import { usePageContext } from "@/lib/brand";

const COLS = [
  ["Products", ["Product Suite", "Income Leaders™", "Enhanced Income", "Fixed Income", "All-In-One"]],
  ["Resources", ["Insights", "Media", "Tax Information", "FAQs", "Distribution Schedule"]],
  ["About", ["About Us", "Investment Philosophy", "Our People", "Contact Us"]],
];

export const SiteFooter = () => {
  const { brand, theme } = usePageContext();
  return (
    <footer className="border-t border-hv-rule bg-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-[1280px] gap-12 px-6 py-16 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <img src={theme.footer_logo} alt={brand === "hhis" ? "Harvest High Income Shares" : "Harvest ETFs"} className="h-12 w-auto" />
          <p className="mt-6 max-w-xs text-sm text-hv-muted">Harvest ETFs are managed by Harvest Portfolios Group Inc.</p>
        </div>
        {COLS.map(([h, items]) => (
          <div key={h}>
            <h2 className="border-b border-hv-rule pb-3 font-heading text-[14px] font-semibold text-hv-text">{h}</h2>
            <ul className="mt-3 space-y-2 font-heading text-[14px] text-hv-text">
              {items.map((i) => <li key={i}><a href="#" className="hover:text-hv-logo-navy">{i}</a></li>)}
            </ul>
          </div>
        ))}
      </div>
      <div className="bg-hv-section">
        <p className="mx-auto max-w-[1280px] px-6 py-8 font-heading text-[12px] leading-[1.6] text-hv-muted" data-testid="footer-disclaimer">
          Commissions, management fees and expenses all may be associated with investing in Harvest Exchange Traded Funds managed by Harvest Portfolios Group Inc. Please read the relevant prospectus before investing. The Funds are not guaranteed, their values change frequently, and past performance may not be repeated. This page is a Ceres pitch prototype and is not affiliated with the live site.
        </p>
      </div>
    </footer>
  );
};
